import React from "react";
import {
    Building2,
    ParkingCircle,
    Target,
    Wrench,
    BadgeCheck,
    MapPin,
    Users2,
    PhoneCall,
} from "lucide-react";
import WhyChooseUs from "../Components/Home_Component/WhyChooseUs";
import ServiceRequestForm from "../Components/ServiceRequestForm";
import MarqueeHighlights from "../Components/MarqueHighlights";

const services = [
    "Puzzle Parking",
    "Puzzle Pit Parking",
    "4 Level Pit Parking",
    "3 Level Parking",
    "3 Level Pit Parking",
    "2 Level Parking",
    "2 Level Pit Parking",
    "Tower Parking",
    "Rotary Parking",
];

const About = () => {
    return (
        <div className="about-wrapper">

            {/* 1. Hero Section */}
            <section className="about-hero">
                <div className="hero-content">
                    <Building2 size={40} />
                    <h1>LIFTECH ENGINEERING PVT. LTD.</h1>
                    <p>
                        India's Trusted Partner for Smart, Automated & Scalable Car Parking Solutions
                    </p>
                </div>
            </section>

            {/* 2. Company Overview */}
            <section className="about-section">
                <h2>About the Company</h2>
                <p>
                    LIFTECH ENGINEERING PVT. LTD. stands as a pioneer in the field of automated and semi-automated car parking solutions across India. With a clear mission to combat the rising challenge of urban parking shortages, we have successfully deployed smart, space-efficient parking technologies in diverse environments—from high-rise residential complexes to commercial hubs and public spaces.
                </p>
                <p>
                    Founded by a team of visionary engineers and industry professionals, Liftech is driven by a commitment to innovation, safety, and sustainability. Our solutions are engineered not only to maximize space but also to enhance the user experience with intuitive, maintenance-friendly designs and state-of-the-art automation systems.
                </p>
                <p>
                    Over the years, we have built a reputation for delivering dependable and scalable systems such as puzzle parking, pit parking, and tower parking, all designed in line with international quality standards and Indian building constraints. Every project we execute reflects our technical precision, material quality, and dedication to client satisfaction.
                </p>
                <p>
                    What sets us apart is our end-to-end project handling—from site inspection, architectural coordination, engineering design, fabrication, and installation, to after-sales service and AMC support. This integrated approach ensures that our clients receive timely, cost-effective, and custom-fit parking solutions tailored to their infrastructure.
                </p>
                <p>
                    As urban spaces continue to shrink and vehicle volumes grow, Liftech remains steadfast in its purpose: to lead the future of intelligent parking systems through continuous research, technological upgrades, and a client-first mindset. We’re not just solving parking problems—we're shaping smarter, more livable cities.
                </p>
            </section>


            {/* 3. Vision & Mission */}
            <section className="about-section">
                <h2>Our Vision & Mission</h2>
                <div className="about-dual-col">
                    <div>
                        <Target size={28} />
                        <h4>Our Vision</h4>
                        <p>
                            To be India’s most trusted and advanced engineering company delivering next-generation parking infrastructure that enhances cityscapes.
                        </p>
                    </div>
                    <div>
                        <Wrench size={28} />
                        <h4>Our Mission</h4>
                        <p>
                            To develop and implement smart parking solutions that are compact, cost-effective, and sustainable for both public and private sectors.
                        </p>
                    </div>
                </div>
            </section>

            {/* 4. Our Expertise */}
            <section className="about-section">
                <h2>Our Expertise</h2>
                <p>
                    With a team of mechanical engineers, structural consultants, and automation experts, Liftech ensures reliable project execution — from design to delivery. Our systems are built with precision engineering, safety compliance, and tailored space configurations, ensuring long-term reliability and maintenance-friendly operations.
                </p>
            </section>

            {/* 5. Our Parking Solutions */}
            <section className="about-section">
                <h2>Our Parking Solutions</h2>
                <div className="services-grid">
                    {services.map((service, index) => (
                        <div className="service-card" key={index}>
                            <ParkingCircle size={22} />
                            <p>{service}</p>
                        </div>
                    ))}
                </div>
            </section>

            <WhyChooseUs />
            <ServiceRequestForm />
            <MarqueeHighlights />
        </div>
    );
};

export default About;
